import { Card, Typography } from 'antd'
import type { CardProps } from 'antd'
import type { ReactNode } from 'react'

const { Paragraph } = Typography

/** Roomier card header + aligned title/extra (list + summary cards). */
export const orgEntityListCardHeaderStyles: NonNullable<CardProps['styles']> = {
  header: {
    minHeight: 52,
    paddingInline: 20,
    paddingBlock: 14,
    alignItems: 'center'
  },
  title: {
    paddingTop: 0,
    paddingBottom: 0
  },
  extra: {
    paddingTop: 0,
    paddingBottom: 0
  }
}

export type OrgEntityListCardProps = {
  title: ReactNode
  extra?: ReactNode
  description?: ReactNode
  children: ReactNode
}

/**
 * Shared list layout: small outlined card, title + primary action in header,
 * optional secondary description, then table or other body content.
 */
export const OrgEntityListCard = ({
  title,
  extra,
  description,
  children
}: OrgEntityListCardProps) => (
  <Card
    size="small"
    variant="outlined"
    title={title}
    extra={extra}
    styles={orgEntityListCardHeaderStyles}
  >
    {description ? (
      <Paragraph type="secondary" style={{ marginBottom: 12 }}>
        {description}
      </Paragraph>
    ) : null}
    {children}
  </Card>
)
